import Utils from "./helpers/utils";

export const constants = {
  imagePath: process.env.PUBLIC_URL,
  contact_number: "919297929272",

  route: {
    root: "/",
    home: "/home",
    about: "/about",
    portfolio: "/portfolio",
    packages: "/packages",
    booking: "/booking",
    contact: "/contact",
    video: "/video",
  },

  categories: [
    {
      name: "Maternity",
      url: Utils.ImagePath("/images/maternity/maternity-25.webp"),
      route: "maternity",
    },
    {
      name: "Newborn",
      url: Utils.ImagePath("/images/newborn/newborn-6.webp"),
      route: "newborn",
    },
    // {
    //   name: "Toddler",
    //   url: Utils.ImagePath("/images/toddler/toddler-31.webp"),
    //   route: "toddler",
    // },
    {
      name: "Cake smash",
      url: Utils.ImagePath("/images/cake-smash/cake-smash-11.webp"),
      route: "cake-smash",
    },
    {
      name: "Outdoor",
      url: Utils.ImagePath("/categories-assets/outdoor.webp"),
      route: "outdoor",
    },
    {
      name: "Blossom Year Package",
      url: Utils.ImagePath("/categories-assets/lifestyle-family.webp"),
      route: "blossom-year-package",
    },
  ],

  termsAndConditions: [
    "Important Note: Cash payments are GST-free. Online payments will attract a mandatory +18% GST as per rules.",
    "Logo placement is mandatory on all provided photography.",
    "Photography and cinematography, being done by electronic equipment, can lose its data on its own. In these situations, we are not responsible or obligated to give you a refund.",
    "All raw data will not be provided.",
    "You will receive only what is included in the package.",
    "Arrive exactly at the scheduled appointment time. If you do not arrive on time, your appointment will be rescheduled for the next day.",
    "50% advance payment is required for booking confirmation. The remaining 50% can be paid after delivery.",
    "Only selected files will be shared (original files).",
    "More packages are available upon request.",
  ],

  reelsRules: [
    {
      title: "BABY REELS AND HIGHLIGHTS",
      rules: ["Reels: ₹3,500", "Highlights: ₹6,000"],
    },
    {
      title: "OUTDOOR CHARGES",
      rules: ["Reels: ₹5000", "Highlights: ₹8,000"],
    },
    {
      title: "AMENDMENTS POLICY",
      rules: ["The song selection cannot be changed after confirmation."],
    },
  ],

  toddlerRules: [
    {
      title: "01 Edited Photo & 1 Theme : ₹800/-",
    },
    {
      title: "03 Edited Photos & 1 Theme: ₹2,000/- (Only for Baby Photography)",
    },
    {
      title: "04 Edited Photos & 2 Themes: ₹2,500/- (Only for Baby Photography)",
    },
  ],

  maternityAndNewbornRules: [
    {
      title: "SINGLE PHOTO CHARGE: ₹1,000/-",
    },
  ],

  photographyPackages: [
    {
      category: "maternity",
      packages: [
        {
          name: "Ultimate 360",
          price: 5000,
          details: [
            "In Studio",
            "1 set-up",
            "1 Dress",
            "06 High Resolution artistically Edited Digital Images",
            "All Unedited Images (JPEG)",
            "Session would be of 1 hour depending on mother's support",
          ],
        },
        {
          name: "Signature 360",
          price: 11999,
          details: [
            "In Studio",
            "3 set-ups",
            "3 Dress",
            "10 High Resolution artistically Edited Digital Images",
            "All Unedited Images (JPEG)",
            "Session would be of 1.5 hours depending on mother's support",
          ],
        },
        {
          name: "Maternelle & Newborn Luxe",
          price: 65000,
          details: [
            "Maternity with YEARLY",
            "23 set-ups",
            "3 sessions maternity - 20 baby session",
            "3 Dress & 3 set-ups - maternity (2 indoor - 1 outdoor)",
            "70 High Resolution artistically Edited Digital Images",
            "All Unedited Images (JPEG)",
            "Festival including",
            "Cake - Smash",
            "2 Reels (35-45 Sec)",
          ],
        },
        {
          name: "Outdoor",
          price: 10000,
          details: [
            "01 outdoor location",
            "1 Dress",
            "10 High Resolution artistically Edited Digital Images",
            "All Unedited Images (JPEG)",
            "1 BTS reel (35 sec)",
            "Session would be of 1-2 hours depending on mother's support",
          ],
        },
      ],
      add_ons: [
        {
          title: "Family Session",
          items: [
            "Rs. 1000/- (2 members), 1 Edited Pictures With Hard Copies.",
          ],
        },
        {
          title: "Edited Pictures",
          items: [
            "Rs. 499/- Per Picture In Soft Copy.",
            "Rs. 799/- Per Picture In Hard Copy.",
          ],
        },
        {
          title: "Reels",
          items: [
            "Rs. 2,000/- For BTS Reel.",
            "Rs. 3,500/- For Camera indoor Reel.",
            "Rs. 5,000/- For Camera outdoor Reel.",
          ],
        },
      ],
      faqs: [
        {
          question: "Does these packages include outfits?",
          answer: [
            "The dress codes are decide a few days prior to the shoot.",
            "Color coordinated outfits add to the beauty of the picture but if its not possible we still make them look great with your smiles.",
            "For the Indoor Studio sessions, I will be providing the drapes (free of cost).",
            "For the Indoor session you will have to arrange for a black and a white lagging and single/spaghetti/tube topi to be worn under the drapes.",
            "I provide maternity gowns/dresses for the shoot on day rental basis.",
            "The images of the dresses and rental costs will be shared subsequent to the session booking.",
          ],
        },
        {
          question: "DOES THIS PACKAGE INCLUDES HAIR & MAKEUP?",
          answer: [
            "Hair and Make-up facilities are not provided in the studio.",
            "You will be expected to get ready at your end and before coming in for the session.",
          ],
        },
        {
          question: "DOES THIS PACKAGE INCLUDES Props?",
          answer: [
            "Studio lights, Jack-props etc. will be arranged by me.",
            "Few props like drapes, headbands, slates, rompers, etc. are brought by me for the shoot.",
            "Any food items if required for a particular set up I will have to be arranged by you.",
            "You can also arrange Props.",
          ],
        },
        {
          question: "Can we conceptualize the theme?",
          answer: [
            "Feel free to discuss any ideas that you have in mind.",
            "If not same i will try my best to recreate a similar concept for you.",
          ],
        },
        {
          question: "Whats the time duration of the OUTDOOR shoot?",
          answer: [
            "The Indoor and outdoor shoot timings are decided upon your Health and convenience.",
            "The garden session is held only near Surat, the time of this session can be kept between 4 pm to sunset as per your convenience.",
            "The beach session is held at Dumas Beach. This session is aimed to be held 2 hours before sunset.",
          ],
        },
        {
          question: "How to make the payment?",
          answer: [
            "Payment Accepted in the form of CASH (New Currency)/ Cheque or NEFT Transfer on the same day of the session.",
          ],
        },
        {
          question: "How are the images shared?",
          answer: [
            "In this session only soft copies will be provided in a drive link.",
            "The drive link will be sent to you within 2 days after your session.",
            "Soft copies are photos that are not in the printed/album form, these can be stored or displayed on a computer/iPad or TV.",
            "Unedited Raw Images will be in low resolution JPEG Format only.",
          ],
        },
        {
          question: "Are the prices negotiable?",
          answer: [
            "I am sure when you get the final product you will see value in them and appreciate the handwork and creativity that goes in every photograph.",
            "Hence i do not look at bargaining for my efforts and creativity with any of my Clients.",
          ],
        },
      ],
    },
    {
      category: "newborn",
      packages: [
        {
          name: "Ultimate 360",
          price: 3500,
          details: [
            "In Studio",
            "1 set-up - one time session",
            "Only wrapping set-up",
            "04 High Resolution artistically Edited Digital Images",
            "All Unedited Images (JPEG)",
            "Session would be of 45 minutes depending on baby's support",
          ],
        },
        {
          name: "Signature 360",
          price: 7000,
          details: [
            "In Studio",
            "2 set-up - one time session",
            "Family sessions included",
            "08 High Resolution artistically Edited Digital Images",
            "All Unedited Images (JPEG)",
            "Session would be of 1-2 hours depending on baby's support",
          ],
        },
        {
          name: "Elite 360",
          price: 10500,
          details: [
            "In Studio",
            "3 set-up - one time session",
            "Family sessions included",
            "12 High Resolution artistically Edited Digital Images",
            "All Unedited Images (JPEG)",
            "Session would be of 2-3 hours depending on baby's support",
          ],
        },
      ],
      add_ons: [
        {
          title: "Family Session",
          items: [
            "Rs. 1000/- (2 members), 1 Edited Pictures With Hard Copies.",
          ],
        },
        {
          title: "Edited Pictures",
          items: [
            "Rs. 499/- Per Picture In Soft Copy.",
            "Rs. 799/- Per Picture In Hard Copy.",
          ],
        },
        {
          title: "Reels",
          items: [
            "Rs. 2,000/- For BTS Reel.",
            "Rs. 3,500/- For Camera indoor Reel.",
            "Rs. 5,000/- For Camera outdoor Reel.",
          ],
        },
      ],
      faqs: [
        {
          question: "Does these packages include outfits and props?",
          answer: [
            "Yes, for these sessions. I will be providing most of the outfit for babies.",
            "Props like Baskets, boxes, tutus, suspenders, bows, crochet garments hats, caps, frames. etc are arranged by me for the session.",
          ],
        },
        {
          question: "When can we schedule the shoot for newborn?",
          answer: [
            "We do a tentative booking for your newborn session depending on your delivery date given during your last sonography.",
            "The final date for the session is decided on the day of your delivery. we need around 10-12days to shift and reschedule dates with other clients to give you a final date.",
            "Thus it is extremely important for someone from your side to inform us on the day of the deliver.",
          ],
        },
        {
          question: "Whats the time duration of the shoot?",
          answer: [
            "The shoot takes maximum about 3-4 Hours.",
            "I would cover different looks and setups depending on the packages chosen.",
            "The timings depend on your baby's sleep schedule, as newborns are best clicked while they are in their deepest sleep.",
            "I give breaks in between the kids to relax, feed, sleep etc.",
            "The shoot is carried out at my commercial studio space in vesu, surat.",
          ],
        },
        {
          question: "How to make the payment?",
          answer: [
            "Payment Accepted in the form of CASH (New Currency)/ Cheque or NEFT Transfer on the same day of the session.",
          ],
        },
        {
          question: "How are the images shared?",
          answer: [
            "In this session only soft copies will be provided in a drive link. The drive link will be sent to you within 2 days after your session.",
            "Soft copies are photos that are not in the printed album form, these can be stored or displayed on a computer/iPad or TV.",
            "Unedited Raw Images will be in low resolution JPEG Format only.",
          ],
        },
        {
          question: "Can we conceptualize the theme?",
          answer: [
            "Feel free to discuss any ideas that you have in mind.",
            "If not same i will try my best to recreate a similar concept for you.",
          ],
        },
        {
          question: "Are the prices negotiable?",
          answer: [
            "I am sure when you get the final product you will see value in them and appreciate the handwork and creativity that goes in every photograph.",
            "Hence i do not look at bargaining for my efforts and creativity with any of my Clients.",
          ],
        },
      ],
    },
    // {
    //   category: "toddler",
    //   packages: [
    //     {
    //       name: "Basic 360",
    //       price: 7999,
    //       details: [
    //         "In Studio",
    //         "5 setups/themes",
    //         "1 time session",
    //         "5 outfit change for the baby",
    //         "10 High Resolution artistically Edited Digital Images",
    //         "20 Unedited Images (JPEG)",
    //         "Images with the PARENTS included",
    //       ],
    //     },
    //     {
    //       name: "Ultimate 360",
    //       price: 11999,
    //       details: [
    //         "In Studio",
    //         "7 setups/themes",
    //         "1 time session",
    //         "7 outfit change for the baby",
    //         "14 High Resolution artistically Edited Digital Images",
    //         "28 Unedited Images (JPEG)",
    //         "Images with the PARENTS included",
    //       ],
    //     },
    //     {
    //       name: "Signature 360",
    //       price: 17999,
    //       details: [
    //         "In Studio",
    //         "10 setups/themes",
    //         "1/2 time session",
    //         "10 outfit change for the baby",
    //         "20 High Resolution artistically Edited Digital Images",
    //         "40 Unedited Images (JPEG)",
    //         "Images with the PARENTS included",
    //         "Booklet Album",
    //       ],
    //     },
    //     {
    //       name: "Elite 360",
    //       price: 39999,
    //       details: [
    //         "Outdoor",
    //         "5 setups/themes",
    //         "1 time session",
    //         "5 outfit change for the baby",
    //         "30 High Resolution artistically Edited Digital Images",
    //         "60 Unedited Images (JPEG)",
    //         "Images with the PARENTS included",
    //         "Exclusive Album",
    //       ],
    //     },
    //   ],
    // },
    {
      category: "cake-smash",
      packages: [
        {
          name: "Ultimate 360",
          price: 6999,
          details: [
            "In Studio",
            "1 set-up",
            "1 outfit change for the baby",
            "06 High Resolution artistically Edited Digital Images",
            "All Unedited Images (JPEG)",
            "Cake included",
          ],
        },
        {
          name: "Signature 360",
          price: 8999,
          details: [
            "In Studio",
            "1 set-up & 1 family set-up",
            "2 outfit change for the baby",
            "10 High Resolution artistically Edited Digital Images",
            "All Unedited Images (JPEG)",
            "Cake included",
            "1 Reel (35-45 Sec)",
          ],
        },
        {
          name: "Elite 360",
          price: 11999,
          details: [
            "Outdoor",
            "2 set-up & 1 family set-up",
            "3 outfit change for the baby",
            "10 High Resolution artistically Edited Digital Images",
            "All Unedited Images (JPEG)",
            "Cake included",
            "1 Reel (35-45 Sec)",
          ],
        },
      ],
      add_ons: [
        {
          title: "Family Session",
          items: [
            "Rs. 1000/- (2 members), 1 Edited Pictures With Hard Copies.",
          ],
        },
        {
          title: "Edited Pictures",
          items: [
            "Rs. 499/- Per Picture In Soft Copy.",
            "Rs. 799/- Per Picture In Hard Copy.",
          ],
        },
        {
          title: "Reels",
          items: [
            "Rs. 2,000/- For BTS Reel.",
            "Rs. 3,500/- For Camera indoor Reel.",
            "Rs. 5,000/- For Camera outdoor Reel.",
          ],
        },
      ],
      faqs: [
        {
          question: "Does these packages include cake and props?",
          answer: [
            "Yes, for these sessions. I will provide most of the props and cake for the children.",
            "Props such as baskets, boxes, tutus, suspenders, bows, caps, frames etc. are arranged by me for the session.",
            "The outfits you will wear for yourself and your child will be discussed a few days before the session.",
            "All professional studio equipment, lights, paper and fabric drops will be available with us.",
          ],
        },
        {
          question: "When can we schedule the shoot for cake smash?",
          answer: [
            "We make provisional bookings for your cake smash session based on your child's date of birth.",
            "The final date for the session is set one week before your child's date of birth.",
          ],
        },
        {
          question: "Whats the time duration of the shoot?",
          answer: [
            "The shoot takes maximum about 1-2 Hours.",
            "I would cover different looks and setups depending on the packages chosen.",
            "The timings depend on your baby's sleep schedule.",
            "I give breaks in between for the kids to relax, feed, sleep etc.",
            "The shoot is carried out at my commercial studio space in vesu, surat.",
          ],
        },
        {
          question: "How to make the payment?",
          answer: [
            "Payment Accepted in the form of CASH (New Currency)/ Cheque or NEFT Transfer on the same day of the session.",
          ],
        },
        {
          question: "How are the images shared?",
          answer: [
            "In this session only soft copies will be provided in a drive link.",
            "The drive link will be sent to you within 2 days after your session.",
            "Soft copies are photos that are not in the printed/album form, these can be stored or displayed on a computer/iPad or TV.",
            "Unedited Raw Images will be in low resolution JPEG Format only.",
          ],
        },
        {
          question: "Can we conceptualize the theme?",
          answer: [
            "Feel free to discuss any ideas that you have in mind.",
            "If not same i will try my best to recreate a similar concept for you.",
          ],
        },
        {
          question: "Are the prices negotiable?",
          answer: [
            "I am sure when you get the final product you will see value in them and appreciate the handwork and creativity that goes in every photograph.",
            "Hence i do not look at bargaining for my efforts and creativity with any of my Clients.",
          ],
        },
      ],
    },
    {
      category: "outdoor",
      packages: [
        {
          name: "Ultimate 360",
          price: 10000,
          details: [
            "outdoor one location",
            "2 Setups/Theme",
            "1 time session",
            "2 outfit change for the baby",
            "05 High Resolution artistically Edited Digital Images",
            "All Unedited Images (JPEG)",
            "1 Reels (35 Sec)",
          ],
        },
        {
          name: "Signature 360",
          price: 15000,
          details: [
            "outdoor one location",
            "3 Setups/Theme",
            "1 time session",
            "3 outfit change for the baby",
            "10 High Resolution artistically Edited Digital Images",
            "All Unedited Images (JPEG)",
            "1 Reels (1.5 minutes)",
          ],
        },
        {
          name: "Elite 360",
          price: 20000,
          details: [
            "outdoor two location",
            "3 Setups/Theme",
            "1 time session",
            "3 outfit change for the baby",
            "20 High Resolution artistically Edited Digital Images",
            "All Unedited Images (JPEG)",
            "1 highlight (2 minutes)",
          ],
        },
      ],
      add_ons: [
        {
          title: "Family Session",
          items: [
            "Rs. 1000/- (2 members), 1 Edited Pictures With Hard Copies.",
          ],
        },
        {
          title: "Edited Pictures",
          items: [
            "Rs. 499/- Per Picture In Soft Copy.",
            "Rs. 799/- Per Picture In Hard Copy.",
          ],
        },
        {
          title: "Reels",
          items: [
            "Rs. 2,000/- For BTS Reel.",
            "Rs. 3,500/- For Camera indoor Reel.",
            "Rs. 5,000/- For Camera outdoor Reel.",
          ],
        },
      ],
      faqs: [
        {
          question: "Does these packages include outfits?",
          answer: [
            "No, we do not provide clothing for outdoor shoots.",
            "Does this packages include outfits?",
            "The dress codes are decide a few days prior to the shoot.",
            "Color coordinated outfits add to the beauty of the picture but if its not possible we still make them look great with your smiles.",
          ],
        },
        {
          question: "DOES THIS PACKAGE INCLUDES HAIR & MAKEUP?",
          answer: [
            "Hair and Makeup facilities are not provided by the studio, you will be expected to prepare yourself before arriving for the session.",
          ],
        },
        {
          question: "DOES THIS PACKAGE INCLUDES Props?",
          answer: [
            "Studio lights, Backdrops etc. will be arranged by me.",
            "Few props like drapes, headband, slates, rompers, etc. are brought by me for the shoot.",
            "Any food items (if required for a particular set up) will have to be arranged by you.",
            "You can also arrange Props",
          ],
        },
        {
          question: "Can we conceptualize the theme?",
          answer: [
            "Feel free to discuss any ideas that you have in mind.",
            "If not same i will try my best to recreate a similar concept for you.",
          ],
        },
        {
          question: "Whats the time duration of the OUTDOOR shoot?",
          answer: [
            "The time of the outdoor shoot is decided keeping in mind the health and convenience of your child.",
            "The garden session is held only near Surat, the time of this session can be kept between 4 pm to sunset as per your convenience.",
            "The beach session is held at Dumas Beach. This session is aimed to be held 2 hours before sunset.",
          ],
        },
        {
          question: "How to make the payment?",
          answer: [
            "Payment Accepted in the form of CASH (New Currency)/ Cheque or NEFT Transfer on the same day of the session.",
          ],
        },
        {
          question: "How are the images shared?",
          answer: [
            "In this session only soft copies will be provided in a drive link.",
            "The drive link will be sent to you within 2 days after your session.",
            "Soft copies are photos that are not in the printed/album form, these can be stored or displayed on a computer/iPad or TV.",
            "Unedited Raw Images will be in low resolution JPEG Format only.",
          ],
        },
        {
          question: "Are the prices negotiable?",
          answer: [
            "I am sure when you get the final product you will see value in them and appreciate the handwork and creativity that goes in every photograph.",
            "Hence i do not look at bargaining for my efforts and creativity with any of my Clients.",
          ],
        },
      ],
    },
    {
      category: "blossom-year-package",
      packages: [
        {
          name: "Ultimate 360",
          price: 35000,
          details: [
            "In Studio",
            "15 set-ups",
            "1 outdoor sessions",
            "15 outfit change for the baby",
            "45 High Resolution artistically Edited Digital Images",
            "All Unedited Images(JPEG)",
            "Festival including",
            "Cake - Smash",
          ],
        },
        {
          name: "Signature 360",
          price: 50000,
          details: [
            "In Studio",
            "20 set-ups",
            "1 outdoor sessions",
            "20 outfit change for the baby",
            "60 High Resolution artistically Edited Digital Images",
            "All Unedited Images(JPEG)",
            "Festival including",
            "Cake - Smash",
            "2Reels (35-45 Sec)",
            "20X30 interior frame",
          ],
        },
        {
          name: "Elite 360",
          price: 65000,
          details: [
            "maternity with YEARLY",
            "23 set-ups",
            "3 sessions maternity - 20 baby session",
            "3 Dress & 3 set-ups - maternity (2 indoor - 1 outdoor)",
            "70 High Resolution artistically Edited Digital Images",
            "All Unedited Images(JPEG)",
            "Festival including",
            "Cake - Smash",
            "2Reels (35-45 Sec)",
          ],
        },
      ],
      add_ons: [
        {
          title: "Family Session",
          items: [
            "Rs. 1000/- (2 members), 1 Edited Pictures With Hard Copies.",
          ],
        },
        {
          title: "Edited Pictures",
          items: [
            "Rs. 499/- Per Picture In Soft Copy.",
            "Rs. 799/- Per Picture In Hard Copy.",
          ],
        },
        {
          title: "Reels",
          items: [
            "Rs. 2,000/- For BTS Reel.",
            "Rs. 3,500/- For Camera indoor Reel.",
            "Rs. 5,000/- For Camera outdoor Reel.",
          ],
        },
      ],
      faqs: [
        {
          question: "Does this packages include outfits?",
          answer: [
            "No. We prefer families to opt for self purchased outfits as and what suits their lifestyle. However we help in co-ordination of outfits.",
            "The kids outfit will be discussed 10 days prior to session via Whats App.",
            "For pictures with parents we generally decide the dress codes over phone, a few day prior to the session.",
            "Generally for family pictures color coordinated outfits are preferred, I do not suggest going the traditional way for coordinating outfits once the shoot date is finalised.",
          ],
        },
        {
          question: "DOES THIS PACKAGE INCLUDES Props?",
          answer: [
            "Studio lights ,backdrops etc. will be arranged by me.",
            "The session is candid lifestyle portfolio for your family.",
          ],
        },
        {
          question: "Can we conceptualize the theme?",
          answer: [
            "Feel free to discuss any ideas that you have in mind.",
            "If not same i will try my best to recreate a similar concept for you.",
            "But no relatives or extended families will be clicked during this session.",
          ],
        },
        {
          question: "Whats the time duration of the INDOOR shoot?",
          answer: [
            "The exact session timings are decided over the phone a week prior to your session.",
          ],
        },
        {
          question: "How to make the payment?",
          answer: [
            "Payment Accepted in the form of CASH (New Currency)/ Cheque or NEFT Transfer on the same day of the session.",
          ],
        },
        {
          question: "How are the images shared?",
          answer: [
            "In this session only soft copies will be provided in a drive link.",
            "The drive link will be sent to you within 2 days after your session.",
            "Soft copies are photos that are not in the printed/album form, these can be stored or displayed on a computer/iPad or TV.",
            "Unedited Raw Images will be in low resolution JPEG Format only.",
          ],
        },
        {
          question: "Are the prices negotiable?",
          answer: [
            "I am sure when you get the final product you will see value in them and appreciate the handwork and creativity that goes in every photograph.",
            "Hence i do not look at bargaining for my efforts and creativity with any of my Clients",
          ],
        },
      ],
    },
  ],
};
